import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const CGU = () => {
  return (
			<div>
				<Header></Header>
				<br />
				<br />
				<br />
				<div class='row  mx-auto  p-5'>
					<div class='card  bg-gradient border-danger border-5' style={{ backgroundColor: '#003300' }}>
						<div class='card-body text-white'>
							<h1 class='card-title text-center'>CONDITIONS GÉNÉRALES D’UTILISATION (CGU)</h1>
							<p class='card-text text-start'>
                <br/>
								<h2>Objet</h2>
                <br/>
								 Les présentes Conditions Générales d’Utilisation ont pour objet de définir les modalités d’accès et d’utilisation du site
								epavistemoro.fr.
                <br/>
                <br/>
                <h2>Accès au site</h2> Le site est accessible gratuitement à tout utilisateur disposant d’un accès à internet. Tous les frais liés à
								l’accès au service (matériel, logiciel, connexion internet) sont à la charge de l’utilisateur.
                <br/>
                <br/>
                <h2>Disponibilité</h2>
                <br/>
                 Le site est accessible 24h/24 et 7j/7, sauf interruption pour maintenance ou cas de force majeure.
                 <br/>
                 <br/>
                 <h2>Responsabilité</h2>
                 <br/>L’éditeur ne pourra être tenu responsable :
                 <li>Des interruptions du site</li>
                 <li>Des bugs ou erreurs</li>
                 <li>De dommages directs ou indirects liés à l’utilisation du site</li>
                 <br/>
                 <br/>
                 <h2>Obligations de l’utilisateur</h2>
                 <br/>L’utilisateur s’engage à :
                 <li>Fournir des informations exactes</li>
                 <li>Ne pas usurper l’identité d’un tiers</li>
                 <li>Ne pas utiliser le site à des fins frauduleuses ou illégales</li>
                 <br/>
                 <br/>
                 <h2>Liens externes</h2>
                 <br/>Le site peut contenir des liens vers d’autres sites. L’éditeur ne peut être tenu responsable du contenu de ces sites.
                 <br/>
                 <br/>
                 <h2>Modification</h2>
                 <br/>
								Les présentes CGU peuvent être modifiées à tout moment. L’utilisateur est invité à les consulter régulièrement.
                <br/>
                <br/>
                <h2>Droit applicable</h2>
                <br/>Le présent site est soumis au droit français.
							</p>
						</div>
					</div>
				</div>
				<br />
				<br />
				<br />
				<br />
				<Footer></Footer>
			</div>
		);
};

export default CGU;
